import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const isConfigValid = firebaseConfig.apiKey && firebaseConfig.projectId;
const useGtagOnly = Boolean(process.env.REACT_APP_GA_MEASUREMENT_ID);

if (!isConfigValid) {
  console.warn('Firebase configuration is missing. Please set REACT_APP_API_KEY and REACT_APP_PROJECT_ID in your .env file');
}

let app;
let analytics;
let db;
let auth;
let storage;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  auth = getAuth(app);

  if (!useGtagOnly) {
    isSupported().then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    }).catch(() => {});
  }

  if (firebaseConfig.storageBucket) {
    try {
      storage = getStorage(app);
    } catch (storageError) {
      console.warn('Firebase Storage initialization failed:', storageError);
    }
  }
} catch (error) {
  console.error('Error initializing Firebase:', error);
}

export { db, analytics, auth, storage };
export default app;
